import { fadeInDown, fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../assets/styles/colors";

const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInAnimation = keyframes`${fadeIn}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const HeaderContainer = styled.div`
  width: ${(props) => (props?.isDesktop ? "550px" : "100%")};
  border-bottom: 1px solid
    ${(props) =>
      props.theme.isDarkTheme ? Color.textColorBlackFor : Color.colorWhite};
  z-index: 9;
  position: fixed;
  background-color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorDarkOne : Color.colorWhite};
  position: fixed;
  margin-top: 5px;
  animation: 1s ${fadeInDownAnimation};
  ${(props) =>
    props?.isDesktop
      ? `box-shadow: 0 0 3px 1px ${
          props.theme.isDarkTheme ? "#1c1c1c" : Color.textColorBlackSeven
        };`
      : `box-shadow: 0 0 6px 2px ${
          props.theme.isDarkTheme
            ? Color.colorDarkOne
            : Color.textColorBlackSeven
        };`}
`;

/////// Detail ////////

export const ContainerDetail = styled.div``;

export const HeaderDetail = styled.div`
  border-bottom: 1px solid
    ${(props) =>
      props.theme?.isDarkTheme
        ? Color.textColorBlackOne
        : Color.textColorBlackSeven};
`;

export const HeaderDetailTitle = styled.span`
  font-weight: bold;
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackSix};
`;

export const HeaderDetailIcon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackOne};
`;

export const DetailLabel = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackFor};
`;

export const DetailValue = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackOne};
`;

export const ContentDetail = styled.div`
  border-bottom: 1px solid
    ${(props) =>
      props.theme?.isDarkTheme
        ? Color.textColorBlackOne
        : Color.textColorBlackSeven};
`;

export const FooterDetail = styled.div``;

/////// End Detail ////////
